import * as marietta from '../../..';
import { Dialog } from '../../../core/view';
import { CONTROL_ACTIONMODE } from '../../Constants';

export default class SketchInputInstructionDialog extends Dialog {
  /**
     * コンストラクタ
     */
  constructor(draggable: boolean) {
    super(draggable);

    let id: string; let title: string; let contents: string; let
      footer: string;

    // ダイアログのコンテンツ生成
    id = 'sketchInputInstructionDialog';
    // タイトル
    switch (marietta.webcad.WebCADGlobal.language) {
      case 'jp': title = 'ペン入力の仕方'; break;
      default: title = 'Pen Input Instruction'; break;
    }
    contents = '<div class="descriptionSketchInput firstView">\n';
    contents += '<ol>\n';
    contents += '<li>\n';
    contents += '<div class="title"><span class="jp">● 壁を描く</span><span class="en">Draw a Wall.</span></div>\n';
    contents += '<div class="descImg" id="descImg1">\n';
    contents += `<img src="${marietta.webcad.WebCADGlobal.webcad2Dmanager.assets_url}description_sketch01.png" width="370" alt="">\n`;
    contents += '</div>\n';
    contents += '<p class="subTitle"><span class="jp">グリッドに沿って線を描く</span><span class="en">Draw a line along the grid</span></p>\n';
    contents += '</li>\n';

    contents += '<li>\n';
    contents += '<div class="title"><span class="jp">●部屋を描く</span><span class="en">Draw a Room.</span></div>\n';
    contents += '<div class="descImg" id="descImg2">\n';
    contents += `<img src="${marietta.webcad.WebCADGlobal.webcad2Dmanager.assets_url}description_sketch02.png"  width="370" alt="下絵調整：入力方法説明図">\n`;
    contents += '</div>\n';
    contents += '<p class="subTitle"><span class="jp">グリッドに沿って閉じた矩形を描く</span><span class="en">Draw a closed rectangle along the grid</span></p>\n';
    contents += '</li>\n';
    contents += '</ol>\n';
    contents += '</div>\n';

    footer = '';
    footer += '<button id="btnChangeMode" value="1"><span class="jp">入力開始</span><span class="en">Start Input</span></button>\n';
    footer += '<button id="btnCancelMode" value="0"><span class="jp">キャンセル</span><span class="en">Cancel</span></button>\n';

    this.createDialog(id, title, contents, footer);

    id = null;
    title = null;
    footer = null;
    contents = null;

    document.querySelector('#btnChangeMode').addEventListener('click', this.onBtnChangeClicked);
    document.querySelector('#btnCancelMode').addEventListener('click', this.onBtnCancelClicked);
  }

    /**
     * キャンセルボタンがクリックされた
     */
    onBtnCancelClicked = (e) => {
      e.preventDefault();
      if (marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode === CONTROL_ACTIONMODE.ACTIONMODE_INPUT_POINT_ROOM) {
        (<HTMLInputElement>document.getElementById('btnRoomKakomiInput')).checked = true;
      } else if (marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode === CONTROL_ACTIONMODE.ACTIONMODE_INPUT_DRAG_ROOM) {
        (<HTMLInputElement>document.getElementById('btnRoomDragInput')).checked = true;
      }
      this.close();
    }

    /**
     * 変更ボタンがクリックされた
     */
    onBtnChangeClicked = (e) => {
      e.preventDefault();
      marietta.webcad.WebCADGlobal.webcad2Dmanager.hasShownSketchInstruction = true;
      marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode = CONTROL_ACTIONMODE.ACTIONMODE_INPUT_ROOM_SKETCH;
      this.close();
    }
}
